import { render, staticRenderFns } from "./UiHeaderDropdownMenu.vue?vue&type=template&id=6dd0f9dc&"
import script from "./UiHeaderDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./UiHeaderDropdownMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports